import { colors, ColorScheme } from '@vechaiui/react';

export const moveColorScheme: ColorScheme = {
  id: 'move',
  type: 'light',
  colors: {
    bg: {
      base: colors.blueGray['900'],
      fill: colors.blueGray['900'],
    },
    text: {
      foreground: colors.blueGray['100'],
      muted: colors.blueGray['300'],
    },
    primary: {
      50: '#DBE1FF',
      100: '#BDC8FF',
      200: '#758CFF',
      300: '#3355FF',
      400: '#0028F0',
      500: '#001DAC',
      600: '#00178A',
      700: '#001166',
      800: '#000B42',
      900: '#000624',
    },
    neutral: colors.blueGray,
  },
};
